import { FlexCol } from '@/src/components'
import { BaseText } from '@/src/components/BaseText'
import { FlexRow } from '@/src/components/flex'
import { appColors } from '@/src/theme'
import { Box } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { BsExclamationTriangle } from 'react-icons/bs'

interface ReferenceTimePeriodWarningProps {
  oldPeriodLabel: string | null
  newPeriodLabel: string
  isCustomBaseLoad?: boolean
}

export const ReferenceTimePeriodWarning = ({
  oldPeriodLabel,
  newPeriodLabel,
  isCustomBaseLoad = false,
}: ReferenceTimePeriodWarningProps) => {
  const { t } = useTranslation()
  const title = isCustomBaseLoad
    ? t('components.procurement.forecasting.reference_period_modal.warning_custom_base_load_title')
    : t('components.procurement.forecasting.reference_period_modal.warning_title')
  const recalculation = isCustomBaseLoad
    ? t('components.procurement.forecasting.reference_period_modal.warning_custom_base_load_recalculation')
    : t('components.procurement.forecasting.reference_period_modal.warning_recalculation')

  return (
    <Box bg={appColors.amber['100']} border='1px solid' borderColor={appColors.amber['400']} borderRadius='md' mt='16px' p='8px'>
      <FlexRow gap='8px' alignItems='flex-start' color={appColors.amber['800']}>
        <BsExclamationTriangle size={16} color={appColors.amber['800']} style={{ minWidth: 16, minHeight: 16, marginTop: 2 }} />
        <FlexCol gap={1}>
          <BaseText>{title}</BaseText>
          <BaseText fontWeight='500'>
            {t('components.procurement.forecasting.reference_period_modal.warning_old_period', { period: oldPeriodLabel ?? '-' })}
          </BaseText>
          <BaseText fontWeight='500'>
            {t('components.procurement.forecasting.reference_period_modal.warning_new_period', { period: newPeriodLabel })}
          </BaseText>
          <BaseText>{recalculation}</BaseText>
        </FlexCol>
      </FlexRow>
    </Box>
  )
}
